import { Card } from "./Card";

import "./CardImage.scss";

export namespace CardImage {
	export type Data = {
		date?: Date;
		badge?: string | { type: "date"; };
		media: {
			type: "image" | "icon";
			src: string;
			alt?: string;
		};
	};
	export type Options = {
		span?: "max";
	};
	export type Props = {
		options: Options;
		data: Data;
	};
}
export class CardImage extends Card<CardImage.Props> {

	override get cls() {
		return {
			...super.cls,
			CardImage: true,
			[`span-${this.props.options.span ?? "normal"}`]: !!this.props.options.span
		};
	}

	protected renderBadge() {
		const { data } = this.props;
		if (!data.badge) return null;
		if (typeof data.badge === "string") {
			return <div class="badge">{data.badge}</div>;
		} else if (data.badge.type === "date" && data.date) {
			const dateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
			return (
				<div class="badge">
					{data.date.toLocaleDateString(undefined, dateOptions)}
				</div>
			);
		}
		return null;
	}

	protected renderMedia() {
		const { data } = this.props;
		return (
			<div class="media">
				{data.media.type === "image" ? (
					<img src={data.media.src} alt={data.media.alt ?? "Card Image"} />
				) : (
					<img class="icon" src={data.media.src} alt={data.media.alt ?? "Card Icon"} />
				)}
				{this.renderBadge()}
			</div>
		);
	}

	public renderReadMoreIcon() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="read-more-icon">
				<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
			</svg>
		);
	}

	public override render() {
		const dateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
		const { data } = this.props;
		return (
			<div class={this.cls} style={this.props.style}>
				{this.renderMedia()}
			</div>
		);
	}
}
